import { DataBean } from "../../DataBean";


export class EthnicGroup extends DataBean {

    public async getEthnicGroupList(args: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getEthnicGroupList_Number", [args]);
    }

}